import { DesignAvatar } from '@components/design-avatar';
import { getScopedTranslate, useScopedTranslate } from '@locale/translate';

import { JourneyAction } from 'api/types';
import { useFlowNodes } from 'ui/journey-builder/hooks/use-nodes';
import { NodeActions } from 'ui/journey-builder/node-types/common';
import { JourneyNodeActionCard } from 'ui/journey-builder/node-types/node-container';
import { NodeContainer } from 'ui/journey-builder/node-types/node-container';
import { JourneyNode } from 'ui/journey-builder/node-types/types';

type ActionType = 'ask_ai_agent';

export const getDescription = (action: JourneyAction<ActionType>) => {
  const { t } = getScopedTranslate(nodeLocale);
  return action.description ?? t('noDescription');
};

export const Node = (node: JourneyNode<ActionType>) => {
  const { t } = useScopedTranslate(nodeLocale);

  useFlowNodes();

  return (
    <NodeContainer node={node}>
      <JourneyNodeActionCard
        isColorful
        node={node}
        label={node.data.values?.name ?? t('title')}
        descriptionText={node.data.description}
        icon={<DesignAvatar src={node.data.values?.picture} />}
      >
        <NodeActions node={node} />
      </JourneyNodeActionCard>
    </NodeContainer>
  );
};

const nodeLocale = {
  en: {
    title: 'Ask AI Agent',
    noDescription: 'No description',
  },
};
